import React, { useEffect, useState, useRef } from 'react';
import './style.css';

const reasons = [
  {
    number: "01",
    title: "Strong Safety Compliance",
    description: "We follow strict safety protocols to protect workers, clients, and the environment."
  },
  {
    number: "02",
    title: "Quality of Service",
    description: "We ensure top-notch workmanship, materials, and project execution from start to finish."
  },
  {
    number: "03",
    title: "Competitive Pricing",
    description: "We offer reliable and high-quality services at fair, market-competitive rates."
  },
  {
    number: "04",
    title: "Timely Project Delivery",
    description: "We respect your deadlines and deliver projects on time without cutting corners."
  },

];


export default function WhyChooseUs() {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="why-container" ref={ref}>
      <h2 className="why-title">WHY CHOOSE US</h2>
      <div className={`why-grid ${visible ? 'active' : ''}`}>
        {reasons.map((reason, index) => (
          <div className="why-card" key={index}>
            <div className="why-number">{reason.number}</div>
            <h3 className="why-card-title">{reason.title}</h3>
            <p className="why-card-desc">{reason.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
